import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { FeatureFlagSelectors, FeatureFlagService } from '@next/core-lib/featureflag';
import { Store } from '@ngrx/store';
import { map, take } from 'rxjs';

import { ShopFeatureFlags } from '../shared/shop-feature-flags';

export const maintenanceModeGuard: CanActivateFn = (_: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const store = inject(Store);
  const featureFlagService = inject(FeatureFlagService);

  if (!featureFlagService.isInitialized) {
    console.error('FeatureFlagService was not initialized, please call initialize() on this service in your app.module constructor.');
    return true;
  }

  return store.select(FeatureFlagSelectors.selectAllFeatureFlags).pipe(
    take(1),
    map((featureFlags) => {
      if (!featureFlags) return true;
      const shouldShowMaintenancePage = featureFlags.includes(ShopFeatureFlags.showShopMaintenancePage);

      // When the maintenance page should not be shown, but someone tries to access it, redirect to the home page
      if (state.url.includes('maintenance')) {
        return shouldShowMaintenancePage ? true : router.parseUrl('');
      }

      return shouldShowMaintenancePage ? router.parseUrl('/maintenance') : true;
    }),
  );
};
